import { SuiteManifest } from '../manifest';
import { hrRoutes } from './routes';

export const hrManifest: SuiteManifest = {
  id: 'hr',
  code: 'S7_HR',
  name: 'HR & Staff',
  basePath: '/hr',
  icon: 'user-check',
  description: 'Faculty command center, tutor marketplace, live tuition session OTPs, performance reviews, load tracking, and payroll.',
  requiredPermission: 'hr.read',
  allowedRoles: ['owner', 'admin', 'branch_head', 'teacher', 'accountant'],
  nav: [
    { label: 'Faculty Command Center', path: '/hr/dashboard', icon: 'zap', group: 'Faculty Portal', status: 'live' },
    { label: 'Live Tuition & OTPs', path: '/hr/live-sessions', icon: 'video', group: 'Faculty Portal', status: 'live' },
    { label: 'Faculty Directory', path: '/hr/teachers', icon: 'graduation-cap', group: 'Faculty Portal', status: 'live' },
    { label: 'Tutor Marketplace', path: '/hr/marketplace', icon: 'sparkles', group: 'Tutor Marketplace', status: 'live' },
    { label: 'Tutor Reviews & Ratings', path: '/hr/reviews', icon: 'star', group: 'Tutor Marketplace', status: 'live' },
    { label: 'All Staff Directory', path: '/hr/staff', icon: 'users', group: 'Directory', status: 'live', allowedRoles: ['owner', 'admin', 'branch_head'] },
    { label: 'Teaching Load', path: '/hr/teaching-load', icon: 'clock', group: 'Workload', status: 'live' },
    { label: 'Leave Requests', path: '/hr/leaves', icon: 'calendar', group: 'Time Off', status: 'live' },
    { label: 'Payroll & Payslips', path: '/hr/payroll', icon: 'credit-card', group: 'Finance', status: 'live', permission: 'hr.payroll.read', allowedRoles: ['owner', 'admin', 'accountant'] },
  ],
  routes: hrRoutes,
};

export { hrRoutes } from './routes';
export default hrManifest;
